import React from "react";

class Select extends React.Component {
	constructor(props) {
		super(props);

		this.state = {};
	}

	insertHtmlElement(htmlString) {
		return { __html: htmlString };
	}

	render() {
		const props = this.props;

		const options =
			props.options && props.options.length > 0
				? props.options.filter(el => !el.hideOption)
				: [];

		return (
			<React.Fragment>
				{props.label && (
					<label className="form__label">
						{props.label}
						{props.requiredStar ? (
							<span
								style={{ color: "#ff0505", opacity: "0.7", paddingLeft: "1px" }}
							>
								*
							</span>
						) : (
							""
						)}
					</label>
				)}
				<div style={{ position: "relative" }}>
					<div className="select-wrapper">
						<select
							name={props.name || ""}
							className="select__input"
							value={props.value}
							disabled={props.disabled}
							onChange={props.selectChange || props.onChange}
							required={props.required}
							{...(props.onClick && { onClick: props.onClick })}
							style={{
								padding: props.padding
									? props.padding
									: props.size === "small"
									? "6px 12px"
									: "9px 12px",
								lineHeight: "1.69",
								marginBottom: props.withMargin ? "20px" : "",
								border:
									props.withError || props.errorText ? "1px solid red" : "",
								width: props.width || "",
							}}
						>
							{" "}
							{props.defaultOption && (
								<option
									value="default"
									dangerouslySetInnerHTML={this.insertHtmlElement(
										props.defaultOption,
									)}
								/>
							)}
							{options.length > 0 &&
								options.map((opt, i) => (
									<option
										key={i}
										{...(opt.disabled && { disabled: opt.disabled })}
										value={opt.value}
										dangerouslySetInnerHTML={this.insertHtmlElement(opt.name)}
									/>
								))}
						</select>
					</div>

					{(props.withError || props.errorText) && (
						<span
							style={{
								position: "absolute",
								fontSize: "11px",
								color: "red",
								bottom: "-17px",
							}}
						>
							{props.errorText}
						</span>
					)}
				</div>
			</React.Fragment>
		);
	}
}

export default Select;
